import React from 'react';
import PropTypes from 'prop-types';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';
import { Button } from '@els/els-react--button';

export const remoteAccessActivationSuccessDialogMessage = 'Your remote access to Reaxys has been successfully activated.';

function ActivationSuccessDialog(props) {
  const { selfClose, message } = props;

  return (
    <DialogWithSuccessLayout
      {...props}
      size="md"
      header="Remote access activated successfully"
      headerClassName="rx-border-none"
      footer={
        <div>
          <Button type="primary" size="small" onClick={selfClose} className="e2e-remote-access-activation-success-ok">
            Got it
          </Button>
        </div>
      }
      footerClassName="rx-border-none">
      {message || remoteAccessActivationSuccessDialogMessage}
    </DialogWithSuccessLayout>
  );
}

ActivationSuccessDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
  message: PropTypes.string,
};

export default ActivationSuccessDialog;
